import { useTranslation } from "react-i18next";
import { DEFAULT_LOCALE, type Locale } from "verdi-common/i18n";
import { isSupportedLocale } from "@/i18n/locale";

/** Returns the active locale string, falling back to the browser locale then a default */
export const useLocale = (): string => {
    const { i18n } = useTranslation();
    return i18n.language || navigator.language || "en-CA";
};

/**
 * verdi-common name lookups like `getUnitCategoryName` want a `Locale` type, so instead
 * of casting a string to `Locale` in every callsite, this is a checked typecast with a
 * fallback in one spot.
 */
export const useSupportedLocale = (): Locale => {
    const locale = useLocale();
    return isSupportedLocale(locale) ? locale : DEFAULT_LOCALE;
};
